(function () {
    'use strict';

    angular.module("imApp").factory("modelService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1162,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1163,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
